// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m52pmv0 {
  flex-basis: 120px;
  flex-shrink: 0;
  height: 60px;
}
@media screen and (min-width: 768px) {
  .m52pmv0 {
    flex-basis: calc(25% - 16px);
    height: 85px;
  }
}
@media screen and (min-width: 1024px) {
  .m52pmv0 {
    flex-basis: calc(20% - 16px);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".m52pmv0 {\n  flex-basis: 120px;\n  flex-shrink: 0;\n  height: 60px;\n}\n@media screen and (min-width: 768px) {\n  .m52pmv0 {\n    flex-basis: calc(25% - 16px);\n    height: 85px;\n  }\n}\n@media screen and (min-width: 1024px) {\n  .m52pmv0 {\n    flex-basis: calc(20% - 16px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
